import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ADD_OR_UPDATE_SOLICITATION_PERIOD } from '../../queries';
import { getTimestampFromDateNTime } from '../../utils/open-reopen-period-util';
import solicitationNotifications from '../../utils/solicitation-notification-helpers';
import { reopenPeriodModalVendorIds } from '../../atoms/solicitation-helpers';
import { MessageType } from '../../../../components/Toast/toast';
import { pageErrorNotifications } from '../../../../utilities/error-handling';

const useEditReopenPeriod = ({
  solicitationID,
  currentPeriodData,
  refetchSolicitation,
} = {}) => {
  const setSolicitationNotification = useSetRecoilState(
    solicitationNotifications,
  );

  const [vndrIds, setVendorIds] = useRecoilState(reopenPeriodModalVendorIds);

  const { period, id: periodId } = currentPeriodData || {};
  const [addSolicitationPeriod] = useMutation(
    ADD_OR_UPDATE_SOLICITATION_PERIOD,
    {
      onError: (requestError) => {
        setSolicitationNotification((prevNotifications) => [
          ...pageErrorNotifications(requestError, {
            id: 'ADD_OR_UPDATE_SOLICITATION_PERIOD_ERROR',
            message: requestError.message,
            type: MessageType.ERROR,
            closeable: false,
            showInModal: false,
          }),
          ...(prevNotifications || []),
        ]);
      },
      onCompleted: () => {
        setVendorIds([]);
        setSolicitationNotification([
          {
            id: period,
            message: `Sucessfully edited ${period}.`,
            type: MessageType.SUCCESS,
            closeable: true,
            showInModal: false,
          },
        ]);
        if (refetchSolicitation) {
          refetchSolicitation();
        }
      },
    },
  );

  const submitEditReopenPeriod = (data) => {
    const { startDate, endDate, startTime, endTime, audience } = data || {};
    if (startDate && endDate && startTime && endTime)
      setSolicitationNotification([]);
    return addSolicitationPeriod({
      variables: {
        solicitationPeriodInput: {
          id: Number(periodId),
          solicitationId: Number(solicitationID),
          startDate: getTimestampFromDateNTime(startDate, startTime),
          endDate: getTimestampFromDateNTime(endDate, endTime),
          audience,
          vendorIds: vndrIds?.length
            ? vndrIds
            : currentPeriodData.solicitationPeriodVendors.map((v) => {
                return {
                  vendorId: v.vendorId,
                  audienceType: v.audienceType,
                };
              }),
        },
      },
    });
  };

  useEffect(() => () => setVendorIds([]), []);
  return {
    submitEditReopenPeriod,
  };
};

export default useEditReopenPeriod;
